import { ReportViewer } from "./report-viewer";
import { MedicalAppointmentProcedure } from "./medical-appointment-procedure";
export class StudyReportText {
  public Id: number;
  public Text: string;
  public Conclusion: string;
  public DocxFilePath: string;
  public XpsFilePath: string;
}

export class StudyReportEditInfo {
  public NoFooter: boolean;
  public NoHeaderLogo: boolean;

  public VisualizeConclusion: boolean;
  public ReportViewer: ReportViewer;
  public StudyReportText: StudyReportText;
  public PatientFullName: string;
  public PatientAge: string;
  public Diagnostic: string;
  public MedicalAppointmentProcedures: MedicalAppointmentProcedure[];
  public StructuredDiagnosisColumns: StructuredDiagnosisColumn[] = [];
  public StructuredDiagnosisColumnItems: StructuredDiagnosisColumnItem[] = [];
  public AppointmentDate?: Date;
  public PhysicianSignatureOne?: number;
  public PhysicianSignatureTwo?: number;
  public PhysicianSignatureThree?: number;
  public PhysicianSignatureFour?: number;
  public PhysicianSignatureFive?: number;
  public PhysicianSignatureSix?: number;
  public AccessionNumbers: number[];
  public CenterId: number;
  public PatientId: number;
}

export interface StructuredDiagnosisColumnItem {
  Id: number | null;
  Name: string;
  Code: string;
  CircuitId: number;
  StepTargetId: number | null;
  ItemParentId: number | null;
  IsClicked: boolean;
  IsSelected: boolean;
  ColumnIndex: number;
}

export  interface StructuredDiagnosisColumn {
  Index: number;
  StepId: number | null;
  Items: StructuredDiagnosisColumnItem[];
}


export class StudykeyImage {
  public KeyImageIds: string[] = [];
  public SelectedKeyImageIds: string[] = [];
  public PatientId: number;
}

